import React from 'react';

// Memoized wrapper for MathJax-processed HTML (question/option/passage text in the
// Ivori exam-simulation layout). React re-renders (e.g. every stopwatch tick) reset
// dangerouslySetInnerHTML-managed DOM back to the raw __html string, silently
// discarding MathJax's in-place DOM mutations. Wrapping the HTML in a memoized
// component whose `html` prop is a plain string (not re-created each render) lets
// React.memo's shallow comparison skip re-rendering — and thus skip re-touching the
// DOM of — this subtree when the underlying text hasn't changed, so MathJax's
// rendered output survives unrelated parent re-renders.
const MathContent = React.memo(function MathContent({ html, className, style, onClick }) {
  return <div className={className} style={style} onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
});

export default MathContent;
